var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "maintenance-page"
  }, [_c("div", {
    staticClass: "maintenance-page-container"
  }, [_c("div", {
    staticClass: "maintenance-page-container-logo-img"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/C&M_White.svg")
    }
  }), _c("h1", [_vm._v("Site Under Maintenance")]), _c("p", [_vm._v("We're working hard to improve the user experience. We will be back soon.")]), _c("MaintenanceCountdown")], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };